/** @file Hook: the client height of an element, kept current by a ResizeObserver. */
import { useEffect, useState, type RefObject } from 'react';

/** Height in px of the element behind `ref`; `initial` until the first measurement. */
export function useElementHeight(ref: RefObject<HTMLElement | null>, initial: number): number {
  const [height, setHeight] = useState(initial);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    setHeight(el.clientHeight);
    const observer = new ResizeObserver(() => { setHeight(el.clientHeight); });
    observer.observe(el);
    return () => { observer.disconnect(); };
  }, [ref]);
  return height;
}
